var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.635363 11.769C0.582671 11.7692 0.530297 11.7608 0.480363 11.744C0.37594 11.7101 0.285578 11.6427 0.223226 11.5524C0.160874 11.462 0.129998 11.3536 0.135363 11.244C0.135363 11.169 0.650363 3.90895 7.93036 3.33895V0.728954C7.93028 0.629548 7.95982 0.532372 8.01523 0.449838C8.07063 0.367303 8.14938 0.303157 8.24142 0.265592C8.33345 0.228027 8.43459 0.218748 8.53193 0.23894C8.62926 0.259132 8.71837 0.307878 8.78786 0.378954L13.7229 5.41895C13.8145 5.51242 13.8658 5.63808 13.8658 5.76895C13.8658 5.89983 13.8145 6.02549 13.7229 6.11895L8.78786 11.159C8.71837 11.23 8.62926 11.2788 8.53193 11.299C8.43459 11.3192 8.33345 11.3099 8.24142 11.2723C8.14938 11.2348 8.07063 11.1706 8.01523 11.0881C7.95982 11.0055 7.93028 10.9084 7.93036 10.809V8.24895C3.07036 8.43395 1.07786 11.499 1.05786 11.5365C1.01275 11.6077 0.950365 11.6664 0.876496 11.707C0.802627 11.7477 0.719678 11.769 0.635363 11.769ZM8.93036 1.95395V3.80645C8.93044 3.93608 8.88017 4.06068 8.79016 4.15396C8.70014 4.24724 8.57742 4.30192 8.44786 4.30645C3.73786 4.47895 2.05286 7.61645 1.44786 9.63395C2.69786 8.55395 4.92536 7.23395 8.40036 7.23395H8.42286C8.55547 7.23395 8.68265 7.28663 8.77642 7.3804C8.87018 7.47417 8.92286 7.60135 8.92286 7.73395V9.58645L12.6729 5.77145L8.93036 1.95395Z",
    fill: "#DB6443"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.24c018d5.svg";
export { ForwardRef as ReactComponent };